/**
 * Shared accessor for the Synth VR editor's live audio AnalyserNode.
 *
 * Timeline.tsx owns the HTMLAudioElement + Web Audio graph and can only create
 * ONE MediaElementSource per element, so it registers its analyser here and any
 * UI that wants the live spectrum (e.g. the playback-bar audio bars) reads from
 * this single node instead of trying to tap the element again.
 */

let analyser: AnalyserNode | null = null;
let freqData: Uint8Array | null = null;

export function setSrAnalyser(a: AnalyserNode | null): void {
  analyser = a;
  freqData = a ? new Uint8Array(a.frequencyBinCount) : null;
}

/** Live byte frequency data (0..255 per bin), or null if no audio is wired. */
export function getSrFrequencyData(): Uint8Array | null {
  if (!analyser || !freqData) return null;
  analyser.getByteFrequencyData(freqData);
  return freqData;
}

/** The raw AnalyserNode, for consumers that drive their own reads (e.g. the
 *  .visualizer scene engine's audio reactivity). */
export function getSrAnalyserNode(): AnalyserNode | null {
  return analyser;
}
